
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" ></ngx-loading>
<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Renew Subscription 111</h5>
   
    <button type="button" class="close" aria-hidden="true" (click)="closeModal()"> <i aria-hidden="true" class="ki ki-close"></i></button>
</div>
<div class="modal-body">
    <form class="form pl-5 pr-5 pt-5" [formGroup]="profileForm">
   
        <!--end::Alert-->
        <div class="form-group">
            <label>Package <span class="asterisk">*</span></label>
            <select class="form-control form-control-lg form-control-solid" formControlName="packageId">
                <option disabled selected value="">Please Select</option>
                <option [value]="i.id" *ngFor="let i of packageList">
                  {{i.name}}
                </option>
              </select>
         
        </div>
        <div class="form-group">
            <label>Payment Method <span class="asterisk">*</span></label>
             <select class="form-control form-control-lg form-control-solid" formControlName="paymentMethod">
                <option disabled selected value="">Please Select</option>
                <option [value]="i.id" *ngFor="let i of paymentMethodList">
                  {{i.name}}
                </option>
              </select>
        </div>
    
     
        </form>
</div>
<div class="modal-footer">
    <!-- <button type="button" class="btn btn-light-primary font-weight-bold" data-dismiss="modal" (click)="closeModal()">Close</button> -->
    <button type="button" class="btn btn-primary font-weight-bold"  [disabled]="!profileForm.valid" (click)="submit()">Renew Subscription</button>
</div>